<template>
  <small :class="[STATUS_COLORS[STATUS.ERROR].CARD_TEXT, 'text-xs']">
    <slot />
  </small>
</template>

<script setup>
import { STATUS, STATUS_COLORS } from '@/app/data/status_constants';
</script>
